export default "__VITE_ASSET__CnjxJ51R__"